/* ============================================================
   Ama Benessere - Sconto visibile nel pannello "La tua selezione"
   ------------------------------------------------------------
   Il tema calcola il totale del bundle a PREZZO PIENO; lo sconto
   Shopify (10%) si applica solo nel carrello. Questo script mostra
   gia' nel pannello lo sconto e il totale scontato quando la
   selezione e' completa (il pulsante "Aggiungi al carrello" e'
   abilitato = numero minimo di prodotti raggiunto).

   NB: la percentuale qui DEVE combaciare con lo sconto automatico
   Shopify "Crea la tua selezione - 10%". Se cambi lo sconto,
   aggiorna anche RATE qui sotto.
   ============================================================ */
(function () {
  var RATE = 0.10; // 10%

  function parseMoney(str) {
    if (!str) return 0;
    var s = str.replace(/[^0-9.,-]/g, '').trim();
    if (s.indexOf(',') > -1) {
      // formato IT: '.' migliaia, ',' decimali
      s = s.replace(/\./g, '').replace(',', '.');
    }
    var n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  }

  function currency() {
    try { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'; }
    catch (e) { return 'EUR'; }
  }

  function fmt(n) {
    try {
      return new Intl.NumberFormat('it-IT', { style: 'currency', currency: currency() }).format(n);
    } catch (e) {
      return '€' + n.toFixed(2).replace('.', ',');
    }
  }

  function enhance(bundle) {
    var footer = bundle.querySelector('.product-bundle__footer');
    var totalEl = bundle.querySelector('[data-product-bundle-total-with-currency]');
    var submit = bundle.querySelector('[data-product-bundle-submit]');
    if (!footer || !totalEl || !submit) return;
    if (footer.__amaBd) return; // gia' inizializzato
    footer.__amaBd = true;

    var box = document.createElement('div');
    box.className = 'ama-bundle-discount hidden';
    box.innerHTML =
      '<div class="ama-bd-row ama-bd-saving">' +
        '<span>Sconto selezione (' + Math.round(RATE * 100) + '%)</span>' +
        '<span class="ama-bd-saving-val"></span>' +
      '</div>' +
      '<div class="ama-bd-row ama-bd-final">' +
        '<span>Totale scontato</span>' +
        '<span class="ama-bd-final-val"></span>' +
      '</div>';

    footer.insertBefore(box, submit);

    // Quanti prodotti sono EFFETTIVAMENTE nella selezione:
    // gli slot vuoti mostrano uno "scheletro" (.horizontal-product__skeleton),
    // quelli pieni no. Contiamo quelli pieni.
    function selectedCount() {
      var slots = bundle.querySelectorAll('[data-product-bundle-variant]');
      var n = 0;
      for (var i = 0; i < slots.length; i++) {
        if (!slots[i].querySelector('.horizontal-product__skeleton')) n++;
      }
      return n;
    }

    var mo;
    var OPTS = { childList: true, subtree: true, attributes: true, characterData: true };

    function setText(el, val) {
      // scrive SOLO se cambia, per non generare mutazioni inutili
      if (el && el.textContent !== val) el.textContent = val;
    }

    function update() {
      // ci si disconnette mentre si modifica il DOM, cosi' le nostre stesse
      // modifiche non ritriggerano l'observer (niente loop / freeze).
      if (mo) mo.disconnect();

      var minimum = parseInt(bundle.getAttribute('data-minimum') || '0', 10);
      var count = selectedCount();
      var total = parseMoney(totalEl.textContent);
      // Sconto mostrato SOLO se ci sono almeno i prodotti richiesti (es. 3)
      // nella selezione e il totale e' valido.
      if (minimum > 0 && count >= minimum && total > 0) {
        var saving = total * RATE;
        setText(box.querySelector('.ama-bd-saving-val'), '-' + fmt(saving));
        setText(box.querySelector('.ama-bd-final-val'), fmt(total - saving));
        box.classList.remove('hidden');
        totalEl.classList.add('ama-bd-original');
      } else {
        // niente sconto: nascondi il box E azzera i valori, cosi' non resta
        // mai un importo "vecchio" appeso quando la selezione non e' completa.
        box.classList.add('hidden');
        setText(box.querySelector('.ama-bd-saving-val'), '');
        setText(box.querySelector('.ama-bd-final-val'), '');
        totalEl.classList.remove('ama-bd-original');
      }

      if (mo) mo.observe(bundle, OPTS);
    }

    // Un solo observer sul pannello bundle: intercetta aggiunte, rimozioni
    // (scheletri che compaiono/scompaiono) e aggiornamenti del totale.
    mo = new MutationObserver(update);
    mo.observe(bundle, OPTS);
    update();
  }

  function init() {
    document.querySelectorAll('product-bundle').forEach(enhance);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // ricarica sezioni nel theme editor
  document.addEventListener('shopify:section:load', init);
})();
